import { variables } from "../Variables";
export const isValidEmail = (value) => value.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export async function sendPublicEmail(kind, fields) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(`${variables.API_URL}Email/${kind === "newsletter" ? "SendNewsletter" : "SendPublicContact"}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal: controller.signal,
      body: JSON.stringify(kind === "newsletter" ? { email: fields.email } : fields),
    });
    if (!response.ok) throw new Error("sendError");
  } finally {
    clearTimeout(timeout);
  }
}
